<template>
  <div class="slim-mainpanel">
    <div class="container">
      <div class="slim-pageheader">
        <ol class="breadcrumb slim-breadcrumb">
          <li class="breadcrumb-item"><a href="#">Operacional</a></li>
          <li class="breadcrumb-item"><a href="#">Importação</a></li>
          <li class="breadcrumb-item"><a href="#">Relatórios</a></li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ mainTitle }}
          </li>
        </ol>
        <h6 class="slim-pagetitle">{{ mainTitle }}</h6>
      </div>

      <div class="bd bd-1 bd-b-0">
        <div
          class="bd-t bd-5 bd-gray-800 pd-x-10 bg-white d-flex justify-content-between align-items-center pd-b-5 pd-t-5"
        >
          <ul class="nav">
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo">
                <a href="#" class="dd-link" data-toggle="dropdown">
                  <div
                    v-if="filter.date.start !== '' && filter.date.end !== ''"
                  >
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-calendar"></i> Período:
                      <span
                        class="pd-x-5 badge mg-b-0 mg-r-2-force tx-thin-force"
                      >
                        {{ filter.date.start | moment("DD/MM/YYYY") }} até
                        {{ filter.date.end | moment("DD/MM/YYYY") }}
                      </span>
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span> <i class="fa fa-calendar mg-r-5"></i> Período</span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-400" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Data do Período
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione uma data inicial e final
                  </p>

                  <div class="form-layout form-layout-2 modify">
                    <div class="row no-gutters">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="form-control-label">
                            Data Inicial <span class="tx-danger">*</span></label
                          >
                          <date-picker lang="pt-br"
                                       v-model="filter.date.start"
                                       name="toPickedDate"
                                       format="DD/MM/YYYY"
                                       placeholder="Data Inicial"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="col-md-6 mg-t--1 mg-md-t-0">
                        <div class="form-group mg-md-l--1">
                          <label class="form-control-label">
                            Data Final <span class="tx-danger">*</span></label
                          >
                          <date-picker lang="pt-br"
                                       v-model="filter.date.end"
                                       name="toPickedDate"
                                       format="DD/MM/YYYY"
                                       placeholder="Data Final"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <ul class="nav nav-white-800 flex-column flex-md-row tx-white tx-15">
            <li class="mg-l-10">
              <div class="btn-group" role="group" aria-label="Ações">
                <button
                  type="button"
                  class="btn btn-primary pd-x-20"
                  @click.prevent="generate('HTML')"
                >
                  <i class="fa fa-file-code-o mg-r-5"></i> GERAR
                </button>
                <download-excel
                  v-if="reportData.totalDocuments > 0"
                  :data="excelData"
                  :fields="excelFields"
                  :name="excelFileName"
                  class="btn btn-success pd-x-20"
                  style="display: inline-block;"
                >
                  <i class="fa fa-file-excel-o mg-r-5"></i> EXCEL
                </download-excel>
              </div>
            </li>
          </ul>
        </div>

        <div class="section-wrapper mg-t-0 pd-0 bd-1 bd-l-0 bd-r-0 bd-b-1">
          <div class="pd-10 mg-10">
            <label class="section-title mg-t-10 tx-16">
              Resultado da Consulta</label
            >
            <div class="row justify-content-between mb-3">
              <div>
                <p class="mg-b-0 ml-3">
                  Foram encontrados {{ reportData.totalDocuments || 0 }} Documentos
                  de acordo com o filtro acima.
                </p>
              </div>
            </div>

            <div class="row mb-4" v-if="reportData.totalDocuments > 0">
              <div class="col-md-6 mg-b-15 mg-md-b-0">
                <div class="card-indicator bg-info bd-rounded">
                  <div class="d-flex align-items-center">
                    <div class="indicator-icon">
                      <i class="fa fa-upload tx-24 text-white"></i>
                    </div>
                    <div class="indicator-content flex-1">
                      <h6 class="text-white mg-b-5 tx-uppercase tx-bold tx-11">
                        Emissão NF X Upload
                        <i 
                          class="fa fa-info-circle mg-l-5 cursor-pointer" 
                          data-toggle="tooltip" 
                          data-placement="top"
                          :title="reportData.averageLeadTime1Hours !== null && reportData.averageLeadTime1Hours !== undefined ? `Tempo médio entre a emissão da NF e o upload do TD10. Média: ${formatDecimalHours(reportData.averageLeadTime1Hours)} horas (${formatDecimalDays(reportData.averageLeadTime1Days)} dias)` : 'Tempo médio entre a emissão da NF e o upload do TD10'"
                        ></i>
                      </h6>
                      <div class="indicator-value text-white tx-20 tx-bold">
                        {{ reportData.averageLeadTime1Formatted }}
                      </div>
                      <div class="text-white tx-11 mg-t-5" v-if="reportData.averageLeadTime1Hours !== null">
                        {{ formatDecimalHours(reportData.averageLeadTime1Hours) }} horas
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card-indicator bg-teal bd-rounded">
                  <div class="d-flex align-items-center">
                    <div class="indicator-icon">
                      <i class="fa fa-clock-o tx-24 text-white"></i>
                    </div>
                    <div class="indicator-content flex-1">
                      <h6 class="text-white mg-b-5 tx-uppercase tx-bold tx-11">
                        Preenchimento X Emissão NF
                        <i 
                          class="fa fa-info-circle mg-l-5 cursor-pointer" 
                          data-toggle="tooltip" 
                          data-placement="top"
                          :title="reportData.averageLeadTime2Hours !== null && reportData.averageLeadTime2Hours !== undefined ? `Tempo médio entre o preenchimento do campo de emissão de NF e a emissão efetiva. Média: ${formatDecimalHours(reportData.averageLeadTime2Hours)} horas (${formatDecimalDays(reportData.averageLeadTime2Days)} dias)` : 'Tempo médio entre o preenchimento do campo de emissão de NF e a emissão efetiva'"
                        ></i>
                      </h6>
                      <div class="indicator-value text-white tx-20 tx-bold">
                        {{ reportData.averageLeadTime2Formatted }}
                      </div>
                      <div class="text-white tx-11 mg-t-5" v-if="reportData.averageLeadTime2Hours !== null">
                        {{ formatDecimalHours(reportData.averageLeadTime2Hours) }} horas
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr/>
            <div class="table-responsive" v-if="reportData.totalDocuments > 0">
              <table class="table table-striped mg-b-0 tx-gray-800 tx-12">
                <thead>
                <tr>
                  <th 
                    class="tx-center cursor-pointer" 
                    @click="sortTable('processReference')"
                    :class="{'bg-gray-200': sortColumn === 'processReference'}"
                  >
                    Referência
                    <i :class="getSortIcon('processReference')" class="mg-l-5"></i>
                  </th>
                  <th 
                    class="tx-center cursor-pointer"
                    @click="sortTable('customerName')"
                    :class="{'bg-gray-200': sortColumn === 'customerName'}"
                  >
                    Cliente
                    <i :class="getSortIcon('customerName')" class="mg-l-5"></i>
                  </th>
                  <th 
                    class="tx-center cursor-pointer"
                    @click="sortTable('operationalTeamName')"
                    :class="{'bg-gray-200': sortColumn === 'operationalTeamName'}"
                  >
                    Time Operacional
                    <i :class="getSortIcon('operationalTeamName')" class="mg-l-5"></i>
                  </th>
                  <th 
                    class="tx-center cursor-pointer"
                    @click="sortTable('wayOfTransport')"
                    :class="{'bg-gray-200': sortColumn === 'wayOfTransport'}"
                  >
                    Modal
                    <i :class="getSortIcon('wayOfTransport')" class="mg-l-5"></i>
                  </th>
                  <th 
                    class="tx-center cursor-pointer"
                    @click="sortTable('fieldFilledDate')"
                    :class="{'bg-gray-200': sortColumn === 'fieldFilledDate'}"
                  >
                    Preenchimento Campo Emissão NF
                    <i :class="getSortIcon('fieldFilledDate')" class="mg-l-5"></i>
                  </th>
                  <th 
                    class="tx-center cursor-pointer"
                    @click="sortTable('nfEmissionDate')"
                    :class="{'bg-gray-200': sortColumn === 'nfEmissionDate'}"
                  >
                    Data p/ Emissão NF
                    <i :class="getSortIcon('nfEmissionDate')" class="mg-l-5"></i>
                  </th>
                  <th 
                    class="tx-center cursor-pointer"
                    @click="sortTable('td10UploadDate')"
                    :class="{'bg-gray-200': sortColumn === 'td10UploadDate'}"
                  >
                    Data Upload
                    <i :class="getSortIcon('td10UploadDate')" class="mg-l-5"></i>
                  </th>
                  <th 
                    class="tx-center cursor-pointer"
                    @click="sortTable('leadTime2')"
                    :class="{'bg-gray-200': sortColumn === 'leadTime2'}"
                  >
                    Lead Time (Preenchimento X Emissão NF)
                    <i :class="getSortIcon('leadTime2')" class="mg-l-5"></i>
                  </th>
                  <th 
                    class="tx-center cursor-pointer"
                    @click="sortTable('leadTime1')"
                    :class="{'bg-gray-200': sortColumn === 'leadTime1'}"
                  >
                    Lead Time (Emissão NF X Upload)
                    <i :class="getSortIcon('leadTime1')" class="mg-l-5"></i>
                  </th>
                  <th class="tx-center">
                    Motivo Prazo
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(document, index) in sortedDocuments" :key="`doc-${document.processId}-${index}`">
                  <td class="tx-center tx-bold" scope="row">
                    <a
                      href="#"
                      @click.prevent="
                          findProcessByIdentificationSearch(
                            document.processReference
                          )
                        "
                      class="text-primary"
                    >
                      {{ document.processReference }}
                    </a>
                  </td>
                  <td class="tx-center">
                    {{ document.customerName || '-' }}
                  </td>
                  <td class="tx-center">
                    {{ document.operationalTeamName || '-' }}
                  </td>
                  <td class="tx-center">
                    {{ wayOfTransport(document.wayOfTransport) }}
                  </td>
				  <td class="tx-center">
					{{ formatDateCell(document.fieldFilledDate) }}
				  </td>
				  <td class="tx-center">
					{{ formatDateCell(document.nfEmissionDate) }}
				  </td>
                  <td class="tx-center">
                    {{ formatDateCell(document.td10UploadDate) }}
                  </td>
				  <td class="tx-center">
					<span 
                      v-if="document.leadTime2" 
                      :class="getLeadTimeTextClass(document.leadTime2.hoursDecimal, true)"
                      class="tx-bold"
                    >
                      {{ document.leadTime2.formatted }}
                    </span>
                    <span v-else class="tx-gray-500">-</span>
				  </td>
                  <td class="tx-center">
                    <span 
                      v-if="document.leadTime1" 
                      :class="getLeadTimeTextClass(document.leadTime1.hoursDecimal)"
                      class="tx-bold"
                    >
                      {{ document.leadTime1.formatted }}
                    </span>
                    <span v-else class="tx-gray-500">-</span>
                  </td>
                  <td class="tx-center">
                    <div
                      v-if="document.hasShortReasonHistory"
                      class="text-center flex ai-c jc-c"
                    >
                      <button
                        class="crm-button sm nps-view-button"
                        @click="openShortReasonModal(document)"
                      >
                        <AssignmentAddIcon :size="18" />
                      </button>
                    </div>
                    <span v-else class="tx-gray-500">-</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Empty State -->
            <div v-else class="empty-state text-center pd-y-40">
              <i class="fa fa-file-text-o tx-60 tx-gray-400 mg-b-20"></i>
              <h5 class="tx-gray-600 mg-b-10">Nenhum documento encontrado</h5>
              <p class="tx-gray-500 tx-14">
                Não foram encontrados documentos para o período selecionado.<br>
                Tente ajustar o filtro de datas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-modal
      :width="900"
      :height="55"
      :title="`Motivo prazo reduzido - ${shortReasonModalData.processReference || ''}`"
      :handler="shortReasonModalOpen"
      description="Histórico de motivos informados para emissão de NF com prazo menor que 15 minutos"
      @requestClose="closeShortReasonModal"
    >
      <template #content>
        <div v-if="shortReasonModalData.histories.length > 0" class="short-reason-modal-list">
          <div
            v-for="history in shortReasonModalData.histories"
            :key="history.id"
            class="short-reason-modal-item"
          >
            <hr />
            <span class="short-reason-modal-date">
              Registrado em
              {{ history.created | moment("DD \\d\\e MMMM \\d\\e YYYY") }} às
              {{ history.created | moment("H:mm:ss") }}
            </span>
            <p class="short-reason-modal-description">{{ history.description }}</p>
            <p class="tx-12 mg-b-1">
              Informado por <strong>{{ history.createdBy }}</strong>
              <span v-if="history.stepDescription">
                na etapa <strong>{{ history.stepDescription }}</strong>
              </span>
            </p>
          </div>
        </div>
        <div v-else class="text-center pd-y-20 tx-gray-500">
          Nenhum histórico encontrado.
        </div>
      </template>
      <template #footer>
        <div class="flex ai-c fgap1 jc-c">
          <button class="crm-button red" @click="closeShortReasonModal">Fechar</button>
        </div>
      </template>
    </v-modal>
  </div>
</template>

<script>
import Axios from "axios";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import JsonExcel from "vue-json-excel";

import config from "@/config.js";
import moment from "moment";
import * as constants from "@/consts.js";

// Helpers
import { formatDateCell, formatDateTime } from "@/helpers/formatDateCell";
import { formatDecimalHours, formatDecimalDays, getLeadTimeTextClass } from "@/helpers/formatLeadTime";
import { getDateSortValue, getLeadTimeSortValue, getStringSortValue } from "@/helpers/tableHelpers";
import VModal from "@/components/VModal.vue";
import AssignmentAddIcon from "@/components/icons/AssignmentAddIcon.vue";

export default {
  name: "OperationalNFIssuance",
  props: [],
  components: {
    DatePicker,
    "download-excel": JsonExcel,
    VModal,
    AssignmentAddIcon,
  },
  data() {
    return {
      mainTitle: "Relatório Indicador de Emissão de NFs",
      filter: {
        date: {
          start: moment().startOf("week").toDate(),
          end: moment().endOf("week").toDate(),
        },
      },
      reportData: {
        totalDocuments: 0,
        averageLeadTime1Hours: null,
        averageLeadTime1Days: null,
        averageLeadTime1Formatted: '-',
        averageLeadTime2Hours: null,
        averageLeadTime2Days: null,
        averageLeadTime2Formatted: '-',
        documents: [],
      },
      sortColumn: null,
      sortDirection: 'asc',
      shortReasonModalOpen: false,
      shortReasonModalData: {
        processReference: '',
        histories: [],
      },
      listOfWayOfTransport: constants.OPERATIONAL_WAY_OF_TRANSPORTE_LABEL,
      excelFields: {
        'Referência': 'Referência',
        'Cliente': 'Cliente',
        'Time Operacional': 'Time Operacional',
        'Modal': 'Modal',
        'Preenchimento Campo Emissão NF': 'Preenchimento Campo Emissão NF',
        'Data p/ Emissão NF': 'Data p/ Emissão NF',
        'Data Upload': 'Data Upload',
        'Lead Time (Preenchimento X Emissão NF)': 'Preenchimento X Emissão NF',
        'Lead Time (Emissão NF X Upload)': 'Emissão NF X Upload',
      },
    };
  },

  methods: {
    // Helpers reutilizáveis
    formatDateCell,
    formatDateTime,
    formatDecimalHours,
    formatDecimalDays,
    getLeadTimeTextClass,

    wayOfTransport(value) {
      const key = (value || "").toUpperCase();
      return (
        this.listOfWayOfTransport.find((option) => option.key === key)
          ?.value ?? "-"
      );
    },

	keepOpen(event) {
      event.preventDefault();
      if (event.target && (event.target.tagName === 'A' || event.target.tagName === 'UL')) {
        const dropdowns = document.querySelectorAll('.dropdown-menu');
        dropdowns.forEach((dropdown) => {
          dropdown.classList.remove('show');
        });
      } 
    },

    sortTable(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fa fa-sort text-gray-400';
      }
      return this.sortDirection === 'asc' 
        ? 'fa fa-sort-asc text-primary' 
        : 'fa fa-sort-desc text-primary';
    },

    generate(type) {
      const {filter} = this;

      if (!filter.date?.start || !filter.date?.end) {
        Swal.fire(
          this.mainTitle,
          "Você precisa selecionar um período para conseguir gerar o relatório.",
          "error"
        );
        return;
      }

      this.$store.commit("setLoading", {
        show: true,
        label: "Relatório Indicador de Emissão de NFs",
        description: "Aguarde enquanto o relatório está sendo gerado...",
      });

      const startDate = this.$moment(filter.date.start).format("Y-MM-DDTLTS");
      const endDate = this.$moment(filter.date.end).format("Y-MM-DDTLTS");

      Axios.get(
        `${config.env.API_DEFAULT.host}/audit/lead-times/nf-average-issuance-time`,
        {
          params: {
            from: startDate,
            to: endDate,
          }
        }
      )
        .then((response) => {
          if (response.data.status === "OK" && response.data.data) {
            this.reportData = {
              totalDocuments: response.data.data.totalDocuments || 0,
              averageLeadTime1Hours: response.data.data.averageLeadTime1Hours !== undefined ? response.data.data.averageLeadTime1Hours : null,
              averageLeadTime1Days: response.data.data.averageLeadTime1Days !== undefined ? response.data.data.averageLeadTime1Days : null,
              averageLeadTime1Formatted: response.data.data.averageLeadTime1Formatted || '-',
              averageLeadTime2Hours: response.data.data.averageLeadTime2Hours !== undefined ? response.data.data.averageLeadTime2Hours : null,
              averageLeadTime2Days: response.data.data.averageLeadTime2Days !== undefined ? response.data.data.averageLeadTime2Days : null,
              averageLeadTime2Formatted: response.data.data.averageLeadTime2Formatted || '-',
              documents: response.data.data.documents || [],
            };

            this.$store.commit("setLoading", {
              show: false,
            });
            
            Swal.fire(
              this.mainTitle,
              response.data.message || "Indicadores calculados com sucesso.",
              "success"
            );
          } else {
            this.$store.commit("setLoading", {
              show: false,
            });
            Swal.fire(
              this.mainTitle,
              response.data.message || "Erro ao gerar o relatório.",
              "error"
            );
          }
        })
        .catch((error) => {
          this.$store.commit("setLoading", {
            show: false,
          });
          
          const errorMessage = error.response?.data?.message 
            || error.message 
            || "Erro ao conectar com o servidor.";
            
          Swal.fire(
            this.mainTitle,
            errorMessage,
            "error"
          );
        });
    },

    async findProcessByIdentificationSearch(identification) {
		// Remove todos os caracteres que não são números
		const identificationNumbersOnly = identification.toString().replace(/\D/g, '');
		const route = this.$router.resolve(`/operational/imp/desk?showProcess=true&identification=${identificationNumbersOnly}`);
		window.open(route.href, '_blank');
    },

    openShortReasonModal(document) {
      this.shortReasonModalData = {
        processReference: document.processReference || '',
        histories: document.shortReasonHistories || [],
      };
      this.shortReasonModalOpen = true;
    },

    closeShortReasonModal() {
      this.shortReasonModalOpen = false;
      this.shortReasonModalData = {
        processReference: '',
        histories: [],
      };
    },
  },
  watch: {},
  computed: {
    sortedDocuments() {
      if (!this.sortColumn || !this.reportData.documents.length) {
        return this.reportData.documents;
      }

      const sorted = [...this.reportData.documents].sort((a, b) => {
        let aValue, bValue;

        switch (this.sortColumn) {
          case 'processReference':
            aValue = getStringSortValue(a.processReference);
            bValue = getStringSortValue(b.processReference);
            break;
          case 'customerName':
            aValue = getStringSortValue(a.customerName);
            bValue = getStringSortValue(b.customerName);
            break;
          case 'operationalTeamName':
            aValue = getStringSortValue(a.operationalTeamName);
            bValue = getStringSortValue(b.operationalTeamName);
            break;
          case 'wayOfTransport':
            aValue = getStringSortValue(a.wayOfTransport);
            bValue = getStringSortValue(b.wayOfTransport);
            break;
          case 'fieldFilledDate':
            aValue = getDateSortValue(a.fieldFilledDate);
            bValue = getDateSortValue(b.fieldFilledDate);
            break;
          case 'nfEmissionDate':
            aValue = getDateSortValue(a.nfEmissionDate);
            bValue = getDateSortValue(b.nfEmissionDate);
            break;
          case 'td10UploadDate':
            aValue = getDateSortValue(a.td10UploadDate);
            bValue = getDateSortValue(b.td10UploadDate);
            break;
          case 'leadTime1':
            aValue = getLeadTimeSortValue(a.leadTime1);
            bValue = getLeadTimeSortValue(b.leadTime1);
            break;
          case 'leadTime2':
            aValue = getLeadTimeSortValue(a.leadTime2);
            bValue = getLeadTimeSortValue(b.leadTime2);
            break;
          default:
            return 0;
        }

        if (aValue < bValue) return this.sortDirection === 'asc' ? -1 : 1;
        if (aValue > bValue) return this.sortDirection === 'asc' ? 1 : -1;
        return 0;
      });

      return sorted;
    },

    excelData() {
      return this.reportData.documents.map(doc => ({
        'Referência': doc.processReference || '',
        'Cliente': doc.customerName || '-',
        'Time Operacional': doc.operationalTeamName || '-',
        'Modal': this.wayOfTransport(doc.wayOfTransport),
        'Preenchimento Campo Emissão NF': formatDateTime(doc.fieldFilledDate),
        'Data p/ Emissão NF': formatDateTime(doc.nfEmissionDate),
        'Data Upload': formatDateTime(doc.td10UploadDate),
        'Preenchimento X Emissão NF': doc.leadTime2 ? doc.leadTime2.formatted : '-',
        'Emissão NF X Upload': doc.leadTime1 ? doc.leadTime1.formatted : '-',
      }));
    },


    excelFileName() {
      return `relatorio-emissao-nf-${this.$moment().format('YYYY-MM-DD-HHmmss')}.xls`;
    },
  },
  mounted() {
    // Inicializar tooltips do Bootstrap
    this.$nextTick(() => {
      if (typeof $ !== 'undefined') {
        $('[data-toggle="tooltip"]').tooltip();
      }
    });
  },
  
  updated() {
    // Atualizar tooltips após mudanças no DOM
    this.$nextTick(() => {
      if (typeof $ !== 'undefined') {
        $('[data-toggle="tooltip"]').tooltip();
      }
    });
  },
};
</script>

<style scoped>
.vs__selected-options span.selected-tag {
  margin: 5px 0px 0px -3px !important;
  padding: 5px !important;
}

.card-indicator {
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.card-indicator:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.indicator-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin-right: 15px;
}

.indicator-value {
  line-height: 1.2;
  margin: 5px 0;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  opacity: 0.8;
}

.empty-state {
  padding: 60px 20px;
}

.bd-rounded {
  border-radius: 8px;
}

.badge-pill {
  padding: 5px 12px;
  font-weight: 500;
}

.table thead th.cursor-pointer:hover {
  background-color: #f8f9fa;
}

.bg-gray-200 {
  background-color: #e9ecef;
}

.text-gray-400 {
  color: #6c757d;
}

.nps-view-button {
  border-radius: 50% !important;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.short-reason-modal-list {
  max-height: 60vh;
  overflow-y: auto;
}

.short-reason-modal-item {
  margin-bottom: 10px;
}

.short-reason-modal-date {
  font-size: 12px;
  color: #6c757d;
}

.short-reason-modal-description {
  font-size: 14px;
  margin: 8px 0;
  white-space: pre-wrap;
}
</style>

